import Login from "@/pages/login"
import RemoteDeskPage from "@/pages/remote_desk"
import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom"
import React from "react"

export const routes = [
  {
    path: "/",
    loader: () => getData(),
    children: [
      {
        path: "/",
        index: true,
        element: <Navigate to="/login" />,
      },
      {
        path: "/login",
        name: "登录",
        element: <Login />,
      },
      {
        path: "/remoteDesk",
        name: "远程桌面",
        element: <RemoteDeskPage />,
      },
    ],
  },
]

const getData = (): RouteObject[] => {
  return routes
}

export const router = createBrowserRouter(routes)
